const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  updateSyncWhsAddrids ({ state, commit, rootState }, params) {
    params = params.params ? params : { params }
    return rootState.axios.post('/user/v1frontend/usermbr/update-sync-whs-addrids', params.params, params.options)
  },
  updateSettings ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/usermbr/update-settings', params).then(res => {
      if (!res.data.error) {
        if (typeof res.data.model.settings === 'string') {
          res.data.model.settings = JSON.parse(res.data.model.settings)
        }
      }
      return res
    })
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/usermbr/update', params)
  },
  updatePricecompcrxIgnoreShopees ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/usermbr/update-pricecompcrx-ignore-shopees', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
